import { Alert, PasswordInput } from '@mantine/core';
import api from '../../api/api';
import { FormModal } from './FormModal';
import { useForm } from 'react-hook-form';
import { useAuth } from '@/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { displayErrorOnReactHookForm } from '@/utils/error/errorHandler';
import { IconInfoCircle } from '@tabler/icons-react';

interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const ChangePasswordModal = ({
  opened,
  onClose,
}: {
  opened: boolean;
  onClose: () => void;
}) => {
  const { setToken } = useAuth();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    getValues,
  } = useForm<ChangePasswordRequest>();

  const onSubmit = handleSubmit(
    async (changePasswordRequest: ChangePasswordRequest) => {
      try {
        await api.post('/users/me/password-change', changePasswordRequest);
        onClose();
        setToken(null);
        navigate('/login');
      } catch (error) {
        displayErrorOnReactHookForm(error, setError);
      }
    }
  );

  return (
    <FormModal
      onConfirm={onSubmit}
      opened={opened}
      onClose={onClose}
      title="Změna hesla"
      size="md"
      confirmText="Uložit heslo"
    >
      <Alert color="blue" icon={<IconInfoCircle />} radius="md" key={'alert'}>
        Po změně budete odhlášeni ze systému Prosaz.
      </Alert>
      <PasswordInput
        label="Zadejte staré heslo"
        variant="filled"
        size="md"
        radius="md"
        {...register('oldPassword')}
        error={errors.oldPassword?.message}
        key={'oldPassword'}
      />
      <PasswordInput
        label="Nové heslo"
        variant="filled"
        size="md"
        radius="md"
        {...register('newPassword')}
        error={errors.newPassword?.message}
        key={'newPassword'}
      />
      <PasswordInput
        label="Zopakujte nové heslo"
        variant="filled"
        size="md"
        radius="md"
        {...register('confirmPassword', {
          validate: match => {
            return match === getValues('newPassword') || 'Hesla se neshodují';
          },
        })}
        error={errors.confirmPassword?.message}
        key={'confirmPassword'}
      />
    </FormModal>
  );
};
